import AppConstants from '../constants/AppConstants';
import FormattedUserProfile from '../models/FormattedUserProfile';
import { UserProfileReq } from '../proxy/proxy';
import { AxiosUserProfileClient } from '../proxy/ProxyClients';

const UserProfileService = {
  get: () => AxiosUserProfileClient.get()
    .then((resp) => new FormattedUserProfile(resp)),
  update: (data: UserProfileReq) => AxiosUserProfileClient.update(data)
    .then((resp) => new FormattedUserProfile(resp)),
  checkGST: () => AxiosUserProfileClient.updateGST()
    .then((resp) => new FormattedUserProfile(resp))
};

export default UserProfileService;
